<template>
  <div class="fixed w-full h-full top-0 left-0 flex items-center justify-center z-30" v-if="isOpen">
    <div class="absolute w-full h-full bg-gray-900 opacity-50"></div>

    <div
      class="absolute max-h-full w-full bottom-0 sm:inset-y-auto overflow-x-hidden overflow-y-auto sm:h-auto sm:max-w-3xl pr-3"
    >
      <div class="h-fit sm:rounded-21px" style="background-color: #f6f6f6">
        <div class="flex justify-between items-start">
          <!--  -->
          <div class="max-h-full w-full">
            <div
              class="px-3 pt-5 cursor-pointer flex items-center gap-1"
              @click="close"
              style="width: fit-content"
            >
              <svg
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="stroke-current text-habu h-6 w-6 stroke-2 transform rotate-0"
              >
                <path d="M11 14L5 8.5 11 3"></path>
              </svg>
              <p class="text-xl text-normal">Close Ticket</p>
            </div>

            <div class="p-3 grid grid-cols-1 gap-3">
              <div class="bg-white z-10 rounded-xl p-4">
                <div class="flex items-center justify-between">
                  <div>
                    <p class="font-bold text-lg">{{ ticket.ticketType.data.alias }}</p>
                    <p class="text-sm text-hgray1 mt-1">
                      {{ ticket.number }}
                      {{ ticket.ticket_activity_id ? ` - ${ticket.ticket_activity_id}` : '' }}
                    </p>
                  </div>
                  <OpenTicket />
                </div>
                <hr class="my-3" />
                <div class="flex flex-col gap-1">
                  <div
                    class="flex items-center gap-2"
                    v-if="ticket.division && ticket.division.data && ticket.division.data.name"
                  >
                    <IconDivision class="w-3.5 h-3.5" />
                    <p class="text-sm font-medium">{{ ticket.division.data.name }}</p>
                  </div>
                  <div
                    class="flex items-center gap-2"
                    v-if="
                      ticket.instrument &&
                      ticket.instrument.data &&
                      ticket.instrument.data.type &&
                      ticket.instrument.data.serial_number
                    "
                  >
                    <IconInstrument class="w-3.5 h-3.5" />
                    <p class="text-sm font-medium">
                      {{ ticket.instrument.data.type }} - {{ ticket.instrument.data.serial_number }}
                    </p>
                  </div>
                  <div class="flex items-center gap-2" v-if="ticket.assigneeName">
                    <IconHuman class="w-3.5 h-3.5" />
                    <p class="text-sm font-medium">{{ ticket.assigneeName }}</p>
                  </div>
                  <div class="flex items-center gap-2" v-if="false">
                    <IconNote class="w-3.5 h-3.5" />
                    <p class="text-sm font-medium">Notes</p>
                  </div>
                  <div
                    v-if="false"
                    class="py-2 px-3 bg-hgray3 mt-2"
                    style="border: 1px solid #e3e3e3; border-radius: 7px; min-height: 80px"
                  >
                    <span class="text-xs font-medium">
                      {{ ticket.description }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="bg-white z-10 rounded-xl p-4" v-if="ticket.summary_ticket">
                <div class="flex items-center gap-2">
                  <IconNote class="w-8 h-8" />
                  <p class="font-bold text-lg">Ticket Summary</p>
                </div>
                <hr class="my-3" />
                <div class="flex flex-col gap-2">
                  <div
                    class="flex flex-col gap-2"
                    v-if="
                      ticket.request &&
                      ticket.ticketType.data.id == 2 &&
                      !['Refresh Training', 'Other'].includes(ticket.request)
                    "
                  >
                    <div
                      class="py-2 px-3 bg-hgray3"
                      style="border: 1px solid #e3e3e3; border-radius: 7px"
                    >
                      <span class="text-xs font-medium"> Do {{ ticket.request }} Checklist</span>
                    </div>
                  </div>
                  <div class="flex flex-col gap-2" v-if="false">
                    <p class="text-xs font-bold text-gray-600">Activity</p>
                    <div
                      class="py-2 px-3 bg-hgray3"
                      style="border: 1px solid #e3e3e3; border-radius: 7px"
                    >
                      <span class="text-xs font-medium">
                        {{ ticket.summary_ticket.activity_name }}
                      </span>
                    </div>
                  </div>
                  <div class="flex flex-col gap-2" v-if="ticket.summary_ticket.problem">
                    <p class="text-xs font-bold text-gray-600">Problem</p>
                    <div
                      class="py-2 px-3 bg-hgray3"
                      style="border: 1px solid #e3e3e3; border-radius: 7px"
                    >
                      <span class="text-xs font-medium">
                        {{ ticket.summary_ticket.problem }}
                      </span>
                    </div>
                  </div>
                  <div class="flex flex-col gap-2" v-if="ticket.summary_ticket.fault_description">
                    <p class="text-xs font-bold text-gray-600">Fault Description</p>
                    <div
                      class="py-2 px-3 bg-hgray3"
                      style="border: 1px solid #e3e3e3; border-radius: 7px"
                    >
                      <span class="text-xs font-medium">
                        {{ ticket.summary_ticket.fault_description }}
                      </span>
                    </div>
                  </div>
                  <div class="flex flex-col gap-2" v-if="ticket.summary_ticket.solution">
                    <p class="text-xs font-bold text-gray-600">Action and Solution</p>
                    <div
                      class="py-2 px-3 bg-hgray3"
                      style="border: 1px solid #e3e3e3; border-radius: 7px"
                    >
                      <span class="text-xs font-medium">
                        {{ ticket.summary_ticket.solution }}
                      </span>
                    </div>
                  </div>
                  <div class="flex flex-col gap-2" v-if="ticket.summary_ticket.notes">
                    <p class="text-xs font-bold text-gray-600">Notes</p>
                    <div
                      class="py-2 px-3 bg-hgray3"
                      style="border: 1px solid #e3e3e3; border-radius: 7px"
                    >
                      <span class="text-xs font-medium">
                        {{ ticket.summary_ticket.notes }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bg-white z-10 rounded-xl p-4">
                <div class="flex items-center justify-between gap-2">
                  <div class="flex items-center gap-2">
                    <IconTime class="w-8 h-8" />
                    <div class="flex flex-col">
                      <p class="font-bold text-lg">Time Confirmation</p>
                      <p class="text-sm font-medium">
                        Konfirmasi waktu pengerjaan yang tercatat untuk memastikan keakuratan
                      </p>
                    </div>
                  </div>
                  <div
                    class="flex items-center gap-2"
                    v-if="timeCorrectionStatus.isValid || timeCorrectionStatus.isInvalid"
                  >
                    <div
                      v-if="timeCorrectionStatus.isValid"
                      class="flex items-center gap-2 px-3 py-2 rounded-lg"
                      style="background-color: #ecfdf5; border: 1px solid #d1fae5"
                    >
                      <svg class="w-4 h-4" viewBox="0 0 20 20" fill="#10b981">
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      <p class="text-xs font-bold text-green-700">Sesuai</p>
                    </div>
                    <div
                      v-if="timeCorrectionStatus.isInvalid"
                      class="flex items-center gap-2 px-3 py-2 rounded-lg"
                      style="background-color: #fdf6ec; border: 1px solid #f57c00"
                    >
                      <svg class="w-4 h-4" viewBox="0 0 20 20" fill="#F57C00">
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      <p class="text-xs font-bold" style="color: #f57c00">Disesuaikan</p>
                    </div>
                    <!-- <div
                      v-if="timeCorrectionStatus.isPending"
                      class="flex items-center gap-2 px-3 py-2 rounded-lg"
                      style="background-color: #fef3c7; border: 1px solid #fde68a"
                    >
                      <svg
                        class="w-4 h-4 animate-spin"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#d97706"
                        stroke-width="2"
                      >
                        <circle cx="12" cy="12" r="10" />
                        <path d="M12 6v6l4 2" />
                      </svg>
                      <p class="text-xs font-bold text-amber-700">Pending</p>
                    </div> -->
                  </div>
                </div>
                <hr class="my-3" />
                <div class="flex flex-col gap-4">
                  <!-- Login Call -->
                  <div class="flex flex-col gap-2">
                    <p class="text-xs font-bold text-gray-600">Login Call</p>
                    <div class="flex items-center justify-betweeen gap-2 w-full">
                      <div
                        class="py-2 px-3 bg-hgray3 rounded-lg w-full"
                        style="border: 1px solid #e3e3e3"
                      >
                        <p class="text-xs font-medium text-gray-600">System</p>
                        <p class="text-sm font-semibold">
                          {{
                            formatDate(
                              listProgress.find(p => p.status === 'opened').created_at.date
                            )
                          }}
                        </p>
                      </div>
                      <div
                        class="py-2 px-3 rounded-lg w-full"
                        :class="timeCorrectionStatus.hasCustomerTime ? 'bg-blue-50' : 'bg-gray-100'"
                        :style="
                          timeCorrectionStatus.hasCustomerTime
                            ? 'border: 1px solid #bfdbfe'
                            : 'border: 1px solid #e3e3e3'
                        "
                        v-if="
                          timeCorrectionStatus.isInvalid &&
                          timeCorrectionStatus.customerLoginCall !==
                            formatDate(
                              listProgress.find(p => p.status === 'opened').created_at.date
                            )
                        "
                      >
                        <p class="text-xs font-medium text-gray-600">Correction Time</p>
                        <p class="text-sm font-semibold">
                          {{ timeCorrectionStatus.customerLoginCall }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <!-- Start -->
                  <div class="flex flex-col gap-2">
                    <p class="text-xs font-bold text-gray-600">Start</p>
                    <div class="flex items-center justify-betweeen gap-2 w-full">
                      <div
                        class="py-2 px-3 bg-hgray3 rounded-lg w-full"
                        style="border: 1px solid #e3e3e3"
                      >
                        <p class="text-xs font-medium text-gray-600">System</p>
                        <p class="text-sm font-semibold">
                          {{
                            formatDate(
                              listProgress.find(p => p.status === 'started').created_at.date
                            )
                          }}
                        </p>
                      </div>
                      <div
                        class="py-2 px-3 rounded-lg w-full"
                        :class="timeCorrectionStatus.hasCustomerTime ? 'bg-blue-50' : 'bg-gray-100'"
                        :style="
                          timeCorrectionStatus.hasCustomerTime
                            ? 'border: 1px solid #bfdbfe'
                            : 'border: 1px solid #e3e3e3'
                        "
                        v-if="
                          timeCorrectionStatus.isInvalid &&
                          timeCorrectionStatus.customerStart !==
                            formatDate(
                              listProgress.find(p => p.status === 'started').created_at.date
                            )
                        "
                      >
                        <p class="text-xs font-medium text-gray-600">Correction Time</p>
                        <p class="text-sm font-semibold">
                          {{ timeCorrectionStatus.customerStart }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <!-- Done -->
                  <div class="flex flex-col gap-2">
                    <p class="text-xs font-bold text-gray-600">Done</p>
                    <div class="flex items-center justify-betweeen gap-2 w-full">
                      <div
                        class="py-2 px-3 bg-hgray3 rounded-lg w-full"
                        style="border: 1px solid #e3e3e3"
                      >
                        <p class="text-xs font-medium text-gray-600">System</p>
                        <p class="text-sm font-semibold">
                          {{
                            formatDate(listProgress.find(p => p.status === 'done').created_at.date)
                          }}
                        </p>
                      </div>
                      <div
                        class="py-2 px-3 rounded-lg w-full"
                        :class="timeCorrectionStatus.hasCustomerTime ? 'bg-blue-50' : 'bg-gray-100'"
                        :style="
                          timeCorrectionStatus.hasCustomerTime
                            ? 'border: 1px solid #bfdbfe'
                            : 'border: 1px solid #e3e3e3'
                        "
                        v-if="
                          timeCorrectionStatus.isInvalid &&
                          timeCorrectionStatus.customerDone !==
                            formatDate(listProgress.find(p => p.status === 'done').created_at.date)
                        "
                      >
                        <p class="text-xs font-medium text-gray-600">Correction Time</p>
                        <p class="text-sm font-semibold">{{ timeCorrectionStatus.customerDone }}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="text-md font-semibold mt-3" v-if="timeCorrectionStatus.isPending">
                  Apakah waktu pengerjaan tiket sesuai ?
                </p>
                <div v-if="timeCorrectionStatus.isPending">
                  <div class="flex gap-2 mt-2">
                    <button
                      class="btn btn-outline rounded-full capitalize h-9 flex-1"
                      style="border: 1px solid #000000"
                      @click="MODAL_CORRECTION_TIME(true)"
                    >
                      Perlu Penyesuaian
                    </button>
                    <button
                      class="btn btn-secondary hover:bg-htealdark rounded-full capitalize h-9 flex-1 hover:border-transparent"
                      @click="confirmTime"
                      :disabled="loadSubmit"
                    >
                      Sesuai
                    </button>
                  </div>
                  <div
                    class="flex items-center justify-center gap-2 mt-3"
                    v-if="errorTimeCorrection"
                  >
                    <img :src="SvgWarning" class="mr-2" />
                    <p
                      class="text-red-500 italic"
                      style="font-size: 14px; line-height: 1; font-weight: 300"
                    >
                      Mohon konfirmasi waktu pengerjaan terlebih dahulu
                    </p>
                  </div>
                </div>
                <div
                  class="flex gap-2 mt-2"
                  v-if="timeCorrectionStatus.hasCustomerTime && !timeCorrectionStatus.isPending"
                >
                  <!-- <button
                    class="btn btn-outline rounded-full capitalize h-9 flex-1"
                    style="border: 1px solid #000000"
                    @click="MODAL_CORRECTION_TIME(true)"
                  >
                    Edit
                  </button> -->
                  <button
                    class="btn btn-outline rounded-full capitalize h-9 flex-1"
                    style="border: 1px solid #666666"
                    @click="CLEAR_PENDING_TIME_CORRECTION"
                  >
                    Cancel
                  </button>
                </div>
                <div
                  class="flex items-center justify-center gap-2 mt-3"
                  v-if="errorTimeCorrection && !timeCorrectionStatus.isPending"
                >
                  <img :src="SvgWarning" class="mr-2" />
                  <p
                    class="text-red-500 italic"
                    style="font-size: 14px; line-height: 1; font-weight: 300"
                  >
                    Mohon konfirmasi waktu pengerjaan terlebih dahulu
                  </p>
                </div>
              </div>

              <!-- ModalCorrectionTime is registered globally in App.vue and controlled via Vuex -->
              <div class="bg-white z-10 rounded-xl p-4" v-if="ratingCategories.length > 0">
                <p class="font-semibold text-base">Service Rating</p>
                <div class="flex flex-col gap-2 mt-2">
                  <div
                    v-for="(item, index) in ratingCategories"
                    :key="index"
                    class="flex items-center justify-between gap-2"
                  >
                    <div class="flex flex-col gap-1">
                      <p>{{ item.name }}</p>
                      <div class="flex items-center gap-1">
                        <template v-for="n in 5">
                          <IconStar
                            v-if="n <= (categoryStars[index] || 0)"
                            :key="'star-' + n"
                            class="fill-current cursor-pointer w-6 h-6"
                            @click="setCategoryStar(index, n)"
                          />
                          <IconStarEmpty
                            v-else
                            :key="'star-empty-' + n"
                            class="fill-current cursor-pointer w-6 h-6 text-hgray3"
                            @click="setCategoryStar(index, n)"
                          />
                        </template>
                      </div>
                    </div>
                    <!-- <p v-if="categoryStars[index] > 0" class="text-base text-hblue font-Nerko">
                      {{ textIcon[categoryStars[index] - 1] }}
                    </p> -->
                  </div>
                  <div
                    class="flex items-center justify-center gap-2 mt-1"
                    v-if="errorRatingCategory"
                  >
                    <img :src="SvgWarning" class="mr-2" />
                    <p
                      class="text-red-500 italic"
                      style="font-size: 14px; line-height: 1; font-weight: 300"
                    >
                      Mohon lengkapi semua penilaian terlebih dahulu
                    </p>
                  </div>
                </div>
              </div>
              <div class="bg-white z-10 rounded-xl p-4">
                <p class="font-semibold text-base text-center">How was your experience overall ?</p>
                <div class="flex items-center justify-center gap-2 mt-3" v-if="errorRating">
                  <img :src="SvgWarning" class="mr-2" />
                  <p
                    class="text-red-500 italic"
                    style="font-size: 14px; line-height: 1; font-weight: 300"
                  >
                    Mohon lengkapi semua penilaian terlebih dahulu
                  </p>
                </div>
                <div class="max-h-20.1 mt-3">
                  <img
                    :src="emoticons[star - 1]"
                    class="mx-auto z-10 relative animate-rating"
                    :key="star"
                  />
                </div>
                <!-- <div class="text-center font-Nerko text-hblue mt-1">
                  {{ textIcon[star - 1] }}
                </div> -->
                <div
                  class="grid grid-cols-5 px-5 gap-3 sm:gap-5 place-items-center mx-auto mt-3 z-10 relative"
                  style="max-width: 400px"
                >
                  <template v-for="n in 5">
                    <IconStar
                      v-if="n <= star"
                      :key="'main-star-' + n"
                      class="fill-current cursor-pointer w-14 h-14"
                      @click="star = n"
                    />
                    <IconStarEmpty
                      v-else
                      :key="'main-star-empty-' + n"
                      class="fill-current cursor-pointer w-14 h-14 text-hgray3"
                      @click="star = n"
                    />
                  </template>
                </div>
                <div class="flex items-center justify-center gap-2 mt-2">
                  <p style="color: #ffa600">Get Points for every ticket you close</p>
                  <IconStarPoint class="w-4 h-4" />
                </div>

                <div class="form-control z-20 relative mt-6 mx-auto">
                  <treeselect
                    ref="reg-cus"
                    class="h-9"
                    v-model="templateSelected"
                    :multiple="false"
                    :options="templateDescriptions"
                    :disabled="loading"
                  />
                </div>

                <div class="form-control z-10 relative mt-4 mb-2 mx-auto">
                  <textarea
                    class="textarea h-24 textarea-bordered placeholder"
                    placeholder="Type note here..."
                    v-model="description"
                  ></textarea>
                </div>
              </div>
              <div class="relative z-10 text-center">
                <button
                  class="btn btn-secondary hover:bg-htealdark rounded-full capitalize h-10 z-5 sm:justify-self-start hover:border-transparent w-full"
                  @click="submit"
                  :class="loadSubmit == true ? 'loading' : ''"
                  :disabled="loadSubmit"
                >
                  Close Ticket
                </button>
              </div>
            </div>

            <div class="relative hidden sm:block">
              <img :src="WaveBack" class="absolute bottom-0 sm:rounded-b-21px" />
              <img :src="WaveFront" class="absolute bottom-0 sm:rounded-b-21px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import SvgClear from '@/assets/icons/icon-close.svg'

import EmoticonOne from '@/assets/icons/emoticon-1star.svg'
import EmoticonTwo from '@/assets/icons/emoticon-2star.svg'
import EmoticonThree from '@/assets/icons/emoticon-3star.svg'
import EmoticonFour from '@/assets/icons/emoticon-4star.svg'
import EmoticonFive from '@/assets/icons/emoticon-5star.svg'

import IconStar from '@/assets/icons/icon-star.svg?inline'
import IconStarEmpty from '@/assets/icons/icon-star-empty.svg?inline'
import IconStarPoint from '@/assets/icons/icon-star-point.svg?inline'
import IconDivision from '@/assets/icons/icon-division.svg?inline'
import IconNote from '@/assets/icons/icon-note.svg?inline'
import IconInstrument from '@/assets/icons/icon-instrument.svg?inline'
import IconHuman from '@/assets/icons/icon-profile.svg?inline'
import SvgWarning from '@/assets/icons/icon-warning.svg'
import OpenTicket from '@/assets/icons/icon-openTicket.svg?inline'
import IconTime from '@/assets/icons/icon-timeColored.svg?inline'

import WaveBack from '@/assets/images/wave-back.png'
import WaveFront from '@/assets/images/wave-front.png'

import Treeselect from '@riophae/vue-treeselect'

export default {
  name: 'ticket-review',
  components: {
    IconStar,
    IconStarEmpty,
    IconStarPoint,
    Treeselect,
    OpenTicket,
    IconDivision,
    IconNote,
    IconInstrument,
    IconHuman,
    IconTime
  },
  data() {
    return {
      SvgClear,
      SvgWarning,

      WaveBack,
      WaveFront,
      emoticons: [EmoticonOne, EmoticonTwo, EmoticonThree, EmoticonFour, EmoticonFive],
      textIcon: ['Very Bad', 'Bad', 'Not Good', 'Good', 'Awesome'],
      description: '',
      star: 0,
      templateSelected: null,
      loading: false,
      loadSubmit: false,
      templateDescriptions: [],
      errorDescription: false,
      errorRatingCategory: false,
      errorRating: false,
      errorTimeCorrection: false,
      ratingCategories: [],
      categoryStars: []
    }
  },
  watch: {
    star: function (val) {
      this.getDraft({
        rating: val
      })
    },
    templateSelected: function (val) {
      this.description = val
    },
    loggedIn: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getDraft({
            rating: this.star
          })
        }
      }
    },
    isOpen: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getRatingCategory()
          this.loadTimeCorrectionData()
        }
      }
    }
  },
  methods: {
    ...mapActions('modal', ['MODAL_REVIEW_TICKET', 'MODAL_THX', 'MODAL_CORRECTION_TIME']),
    ...mapActions('ticket', [
      'COMMENT_DRAFTS',
      'TICKET_CLOSE',
      'GET_RATING_CATEGORY',
      'TICKET_CORRECTION_TIME',
      'SET_PENDING_TIME_CORRECTION',
      'CLEAR_PENDING_TIME_CORRECTION',
      'TICKET_CORRECT_TIME'
    ]),
    setCategoryStar(index, value) {
      this.$set(this.categoryStars, index, value)
    },
    async confirmTime() {
      this.loadSubmit = true
      const systemLoginCall = this.listProgress.find(p => p.status === 'opened')?.created_at.date
      const systemStart = this.listProgress.find(p => p.status === 'started')?.created_at.date
      const systemDone = this.listProgress.find(p => p.status === 'done')?.created_at.date

      // Store the time correction data in state instead of submitting immediately
      this.SET_PENDING_TIME_CORRECTION({
        ticketId: this.ticket.id,
        data: {
          customer_login_call_at: this.toApiDatetime(systemLoginCall),
          customer_start_at: this.toApiDatetime(systemStart),
          customer_done_at: this.toApiDatetime(systemDone)
        }
      })

      this.loadSubmit = false
    },
    toApiDatetime(dateString) {
      if (!dateString) return ''
      const cleanString = dateString.split('.')[0].replace(' ', 'T')
      const withSpace = cleanString.replace('T', ' ')
      return withSpace.length === 16 ? withSpace + ':00' : withSpace
    },
    close() {
      this.MODAL_REVIEW_TICKET(false)
    },
    async getRatingCategory() {
      let res = await this.GET_RATING_CATEGORY()
      if (res) {
        this.ratingCategories = res
        this.categoryStars = Array(res.length).fill(0)
      }
    },
    async getDraft(val) {
      this.loading = true
      this.templateSelected = null
      let res = await this.COMMENT_DRAFTS(val)
      if (res) {
        let temp = []
        if (Array.isArray(res) && res.length) {
          res.forEach(d => {
            temp.push({
              id: d.draft,
              label: d.draft
            })
          })
        }
        this.templateDescriptions = temp
      }

      this.loading = false
    },
    formatDate(dateString) {
      if (!dateString) return ''
      // Remove microseconds if present and ensure T separator
      const cleanString = dateString.split('.')[0].replace(' ', 'T')
      const date = new Date(cleanString)
      if (isNaN(date)) return dateString

      const dateOptions = {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      }
      const timeOptions = {
        hour: '2-digit',
        minute: '2-digit'
      }

      const datePart = date.toLocaleString('en-GB', dateOptions)
      const timePart = date.toLocaleString('en-GB', timeOptions)

      return `${datePart} - ${timePart}`
    },
    formatDisplay(dateString) {
      if (!dateString) return ''
      const clean = dateString.split('.')[0].replace(' ', 'T')
      const date = new Date(clean)
      if (isNaN(date)) return dateString
      const day = String(date.getDate()).padStart(2, '0')
      const month = date.toLocaleString('en-GB', { month: 'short' })
      const year = date.getFullYear()
      const hh = String(date.getHours()).padStart(2, '0')
      const mm = String(date.getMinutes()).padStart(2, '0')
      return `${day} ${month} ${year} - ${hh}:${mm}`
    },

    async loadTimeCorrectionData() {
      if (this.ticket && this.ticket.id) {
        // Only skip loading if there are pending changes for THIS ticket
        const hasPendingForThisTicket =
          this.pendingTimeCorrection && this.pendingTimeCorrectionTicketId === this.ticket.id
        if (!hasPendingForThisTicket) {
          await this.TICKET_CORRECTION_TIME(this.ticket.id)
        }
      }
    },

    async submit() {
      this.loadSubmit = true
      this.errorDescription = false
      this.errorRatingCategory = false
      this.errorRating = false
      this.errorTimeCorrection = false

      // Validate time correction - must confirm/submit before closing
      // if (this.timeCorrectionStatus.isPending) {
      //   this.errorTimeCorrection = true
      //   this.loadSubmit = false
      //   return
      // }

      // Validate category ratings
      if (this.ratingCategories.length > 0) {
        const allRated = this.categoryStars.every(star => star > 0)
        if (!allRated) {
          this.errorRatingCategory = true
          this.loadSubmit = false
          return
        }
      }

      // Validate overall rating
      if (this.star === 0) {
        this.errorRating = true
        this.loadSubmit = false
        return
      }

      // Prepare category ratings
      const categoryRatings = this.ratingCategories.map((cat, idx) => ({
        id: cat.id || cat.name,
        rating: this.categoryStars[idx] || 0
      }))

      // First, submit pending time correction if it exists for this ticket
      if (this.pendingTimeCorrection && this.pendingTimeCorrectionTicketId === this.ticket.id) {
        await this.TICKET_CORRECT_TIME({
          id: this.ticket.id,
          data: this.pendingTimeCorrection
        })
        this.CLEAR_PENDING_TIME_CORRECTION()
      }

      await this.TICKET_CLOSE({
        ticket_id: this.ticket.id,
        rating: this.star,
        comment: this.description,
        category_ratings: categoryRatings
      })

      this.MODAL_REVIEW_TICKET(false)
      this.MODAL_THX(true)

      this.loadSubmit = false
    }
  },
  computed: {
    isOpen: {
      get: function () {
        return this.$store.state.modal.reviewTicket
      },
      set: function (value) {
        this.MODAL_REVIEW_TICKET(value)
      }
    },
    ...mapState({
      ticket: state => state.ticket.ticket,
      loggedIn: state => state.auth.loggedIn,
      ticketCorrectionTime: state => state.ticket.ticketCorrectionTime,
      pendingTimeCorrection: state => state.ticket.pendingTimeCorrection,
      pendingTimeCorrectionTicketId: state => state.ticket.pendingTimeCorrectionTicketId
    }),
    ...mapGetters('ticket', ['listProgress']),
    timeCorrectionStatus() {
      const ct = this.ticketCorrectionTime
      const hasCustomerTime =
        ct && (ct.customer_login_call_at || ct.customer_start_at || ct.customer_done_at)
      return {
        isValid: ct?.is_valid === true,
        isInvalid: ct?.is_invalid === true,
        isPending: ct?.is_pending === true,
        confirmedBy: ct?.customer_confirmed_by_name || '',
        confirmedAt: ct?.customer_confirmed_at ? this.formatDisplay(ct.customer_confirmed_at) : '',
        hasCustomerTime: !!hasCustomerTime,
        customerLoginCall: ct?.customer_login_call_at
          ? this.formatDisplay(ct.customer_login_call_at)
          : '-',
        customerStart: ct?.customer_start_at ? this.formatDisplay(ct.customer_start_at) : '-',
        customerDone: ct?.customer_done_at ? this.formatDisplay(ct.customer_done_at) : '-'
      }
    }
  }
  // mounted() {
  //   this.getRatingCategory()
  // }
}
</script>
